import { useEffect, useRef, useState } from "react";
import { Generico } from "../../components/Generico";
import { Transaccion } from "../../models/monitoreo/Transaccion";
import { useForm } from "react-hook-form";
import { useToken } from "../../components/useToken";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { CatalogoService } from "../../service/CatalogoService";
import { Dialog } from "primereact/dialog";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import '../../components/estilo.css';
import { ToggleButton } from "primereact/togglebutton";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { FiltroUnicoAutocomplete, FiltroUnicoCatalogoFijo } from "../../components/ui/FiltrosGlobales";
import { FileUpload } from "primereact/fileupload";
pdfMake.addVirtualFileSystem(pdfFonts);

export const MonitoreoTransaccion = () => {
    const generic = Generico();
    const { stringToDate } = generic;
    const omodel = new Transaccion();
    const [permss, setPermss] = useState(null);
    const [funcionalidades, setFuncionalidades] = useState([]);
    const defaultValues = generic.funDefault(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, watch } = useForm({ defaultValues, shouldTrim: true });
    const { getRol } = useToken();
    const monitoreoService = new MonitoreoService();
    const toast = useRef(null);
    const menuRef = useRef(null);
    const [item, setItem] = useState(null);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { inDrop, inDropMultiple, inText, inNumber, inCalendar, inAutocomplete } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const [catalogos, setCatalogos] = useState({});
    const [dialogTransaccion, setDialogTransaccion] = useState(false);
    const [dialogFechas, setDialogFechas] = useState(false);
    const [tipoReporte, setTipoReporte] = useState('pdf');
    const [load, setLoad] = useState(false);
    const [loadExcel, setLoadExcel] = useState(false);
    const [loadPdf, setLoadPdf] = useState(false);
    const [rangoFechas, setRangoFechas] = useState([null, null]);
    const [diasMaxDescargaReporte, setDiasMaxDescargaReporte] = useState(31);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorId, setEcuadorId] = useState(null);
    const [ecuador, setEcuador] = useState(false);
    const [catalogoClientes, setCatalogoClientes] = useState([]);
    const [modoReporte, setModoReporte] = useState('cliente');
    const [buscarPorNombre, setBuscarPorNombre] = useState(true);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const empresasSeleccionadas = watch('empresa') || [];
    const catalogoSrv = new CatalogoService();
    const stepperRef = useRef(null);
    const minDate = new Date('2025-01-01');
    const maxDate = new Date();
    // Estados para la carga masiva
    const [esAdmin, setEsAdmin] = useState(false);
    const [empresaSelUpload, setEmpresaSelUpload] = useState(null);
    const [dialogUpload, setDialogUpload] = useState(false);
    const [archivoMasivo, setArchivoMasivo] = useState(null);
    const [loadUpload, setLoadUpload] = useState(false);
    const fileUploadRef = useRef(null);


    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        monitoreoService.listado('monitoreo/transaccion/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setFuncionalidades(res.data.funcionalidades);
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
            if (res.data.esAdmin !== undefined) {
                setEsAdmin(res.data.esAdmin);
            }
            if (res.data.tipo_identificacion) {
                setCatalogos(prev => ({ ...prev, tipo_identificacion: res.data.tipo_identificacion.map(p => ({ label: p.nombre, value: p.cat_id })) }));
            }
            if (res.data.instrumento_pago) {
                setCatalogos(prev => ({ ...prev, instrumento_pago: res.data.instrumento_pago.map(p => ({ label: p.nombre, value: p.cat_id })) }));
            }
            if (res.data.tipo_producto) {
                setCatalogos(prev => ({ ...prev, tipo_producto: res.data.tipo_producto.map(p => ({ label: p.nombre, value: p.cat_id })) }));
            }
            if (res.data.catalogo_empresas) {
                setCatalogos(prev => ({ ...prev, catalogo_empresas: res.data.catalogo_empresas.map(e => ({ label: e.razon_social, value: e.emp_id })) }));
            }
            if (res.data.paises) {
                const paisesCatalogo = res.data.paises.map(p => ({ label: p.nombre, value: p.cat_id }));
                setCatalogos(prev => ({ ...prev, paises: paisesCatalogo }));
                const ecuador = paisesCatalogo.find(p => p.label === 'Ecuador');
                if (ecuador) { setEcuadorId(ecuador.value); }
            }
            if (res.data.provincias) {
                setCatalogos(prev => ({ ...prev, provincias: res.data.provincias.map(p => ({ label: p.nombre, value: p.cat_id })) }));
            }
            if (res.data.dias_max_descarga_reporte !== undefined) {
                setDiasMaxDescargaReporte(res.data.dias_max_descarga_reporte);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogTransaccion(true);
    };

    const edit = () => {
        monitoreoService.consultar(item?.id, 'monitoreo/transaccion/consulta').then(res => {
            const _item = res.data.transaccion;
            setClienteSeleccionado({
                cli_id: _item.cli_id,
                nombres: _item.nombres,
                identificacion: _item.identificacion,
                tipo_identificacion_id: _item.tipo_identificacion
            });
            const esEcuador = _item.pais_id === ecuadorId;
            _item.fecha = stringToDate(_item.fecha);
            setEcuador(esEcuador);
            if (res.data.ciudades && esEcuador) {
                setCiudades(res.data.ciudades);
            }
            reset(generic.renewValues(_item, omodel.model));
            setDialogTransaccion(true);
        });
    };

    const deleteItem = () => {
        confirmDialog({
            group: 'confirmar',
            message: '¿Está seguro de eliminar la transacción?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                monitoreoService.eliminar(item?.id, 'monitoreo/transaccion/eliminar').then(res => {
                    generic.funcSuccess(res, toast);
                    loadLazyData();
                }).catch(err => {
                    generic.funcDeleteError(err, toast);
                });
            }
        });
    };

    const onChangePais = (e) => {
        setValue('pais_id', e.value);
        setEcuador(e.value === ecuadorId);
    };

    const onChangeProvincia = (e) => {
        setValue('provincia_id', e.value);
        if (e?.value) {
            catalogoSrv.getCatalogosId(e.value).then(res => {
                setCiudades(res.data);
            });
        }
    };

    const onSubmit = (data) => {
        if (!clienteSeleccionado) {
            toast.current.show({ severity: 'error', summary: 'Debe seleccionar un cliente', life: 3000 });
            return;
        }
        // Campos que no se deben enviar
        delete data.nombres;
        delete data.identificacion;
        delete data.tipo_identificacion;

        data.cliente_id = clienteSeleccionado.cli_id;
        data.es_ecuador = ecuador;
        if (getValues('id') == null) {
            setLoad(true);
            monitoreoService.nuevo(data, 'monitoreo/transaccion/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogTransaccion(false);
                reset();
                reset({ nombres: '', identificacion: '', tipo_identificacion: '' });
                loadLazyData();
                setClienteSeleccionado(null);
            }).catch(err => {
                setLoad(false);
                generic.funcErrorHibrida(err, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        } else {
            setLoad(true);
            monitoreoService.editar(data, 'monitoreo/transaccion/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogTransaccion(false);
                reset();
                reset({ nombres: '', identificacion: '', tipo_identificacion: '' });
                loadLazyData();
                setClienteSeleccionado(null);
            }).catch(err => {
                generic.funcErrorHibrida(err, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    };

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setItem(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );


    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && siOpcion('monitoreo-transaccion-editar-registro'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.eliminar && siOpcion('monitoreo-transaccion-eliminar-registro'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-credit-card icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nueva Transacción" : " Editar Transacción"}
                </span>
            </div>
        );
    }

    const buscarClientes = (seleccionado) => {
        const texto = seleccionado?.query;
        const tipoIdentificacion = Number(getValues('tipo_identificacion'));
        if (texto.length < 3) { setCatalogoClientes([]); return; }
        const params = { texto, rol: JSON.stringify(getRol()), tipo_identificacion: tipoIdentificacion }
        monitoreoService.consultarInfo('monitoreo/transaccion/consultar-clientes', params).then(res => {
            const clientesConLabel = res.data.map(c => ({ ...c, label: `${c.nombres} - ${c.identificacion}` }));
            setCatalogoClientes(clientesConLabel);
        }).catch(err => {
            generic.funcError(err, toast, setError);
        });
    };

    const generarDetalleTransaccion = (detalles, info) => {
        const body = [];
        let contador = 1;

        // Existe un valor para el reporte?
        const incluirTipoProducto = detalles.some(t => t.tipo_producto)
        const incluirValor1 = detalles.some(t => t.valor1);
        const incluirValor2 = detalles.some(t => t.valor2);

        detalles.forEach(transaccion => {
            const fila = [
                contador++,
                transaccion.cliente,
                transaccion.empresa,
                transaccion.identificacion,
                transaccion.tipo_instrumento,
                transaccion.codigo,
                transaccion.valor,
            ];

            if (incluirValor1) fila.push(transaccion.valor1 || '-');
            if (incluirValor2) fila.push(transaccion.valor2 || '-');
            if (incluirTipoProducto) fila.push(transaccion.tipo_producto || '-');
            fila.push(
                transaccion.detalle,
                transaccion.pais,
                transaccion.provincia || '-',
                transaccion.ciudad,
                transaccion.fecha_transaccion,
                transaccion.fecha_registro
            );

            body.push(fila);
        });

        const docDefinition = omodel.template(body, info, { incluirValor1, incluirValor2, incluirTipoProducto });
        pdfMake.createPdf(docDefinition).download('Listado_transacciones.pdf');
    };

    const exportar = () => {
        const [fechaInicio, fechaFin] = rangoFechas;
        if (!fechaInicio || !fechaFin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Seleccione el rango de fechas', life: 6000 });
            return;
        } else if (fechaInicio > fechaFin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La fecha de inicio debe ser menor o igual a la fecha de fin', life: 6000 });
            return;
        } else if (generic.fechasDiferenciaEnDias(fechaInicio, fechaFin) > diasMaxDescargaReporte) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `El rango de fechas no puede superar los ${diasMaxDescargaReporte} días`, life: 6000 });
            return;
        }
        setLoadPdf(tipoReporte === 'pdf');
        setLoadExcel(tipoReporte === 'xlsx');
        const clienteId = clienteSeleccionado?.cli_id;
        const params = {
            rol: getRol(),
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            cliente_id: clienteId ?? null,
            empresas_seleccionadas: clienteId ? null : empresasSeleccionadas.length > 0 ? empresasSeleccionadas : null
        };

        if (tipoReporte === 'xlsx') {
            monitoreoService.generarDocumento(`monitoreo/transaccion/reporte/${tipoReporte}`, params).then(res => {
                generic.downloadPdf(res.data, 'Listado_transacciones.xlsx');
            }).catch((error) => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
                setLoadExcel(false);
            });
        } else {
            monitoreoService.consultarInfo(`monitoreo/transaccion/reporte/${tipoReporte}`, params).then(res => {
                generarDetalleTransaccion(res.data.detalle, res.data.info);
            }).catch((error) => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
                setLoadExcel(false);
            });
        }
    };

    const dialogFechasHeader = () => {
        const label = tipoReporte === 'pdf' ? 'PDF' : tipoReporte === 'xlsx' ? 'Excel' : '';
        const icon = tipoReporte === 'pdf' ? 'pi pi-file-pdf' : 'pi pi-file-excel';
        return (
            <div className="flex align-items-center gap-2">
                <i className={`text-xl ${icon}`} />
                <span className="text-lg font-semibold">
                    Seleccionar el rango de fechas para el reporte {label}
                </span>
            </div>
        );
    };

    const descargarPlantillaCargaMasiva = () => {
        setLoadExcel(true);
        monitoreoService.generarDocumento('monitoreo/cliente/descargar-plantilla').then((res) => {
            generic.downloadPdf(res.data, 'plantilla_clientes_transacciones.xlsx');
            toast.current.show({ severity: 'success', summary: 'Archivo', detail: `Plantilla descargada`, life: 6000 });
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadExcel(false);
        });
    };

    const solicitarFechas = (tipo) => {
        setTipoReporte(tipo);
        setDialogFechas(true);
    };

    const rightTool = () => (
        <div className="flex align-items-center gap-4">
            <div className="flex align-items-center gap-2 border-right-1 surface-border pr-4">
                <Button onClick={descargarPlantillaCargaMasiva} className="p-button-secondary" tooltip="1. Descargar plantilla" tooltipOptions={{ position: 'top' }} icon="pi pi-download" loading={loadExcel} />
                <Button onClick={() => setDialogUpload(true)} className="p-button-info" tooltip="2. Subir plantilla llena" tooltipOptions={{ position: 'top' }} icon="pi pi-cloud-upload" />
            </div>
            <div className="flex align-items-center gap-2">
                <Button onClick={() => solicitarFechas('pdf')} className="p-button-danger" tooltip="Exportar transacciones a PDF" tooltipOptions={{ position: 'top' }} icon="pi pi-file-pdf" loading={loadPdf} disabled={loadExcel} raised />
                <Button onClick={() => solicitarFechas('xlsx')} className="p-button-success" tooltip="Exportar transacciones a Excel" tooltipOptions={{ position: 'top' }} icon="pi pi-file-excel" loading={loadExcel} disabled={loadPdf} raised />
            </div>
        </div>
    );

    const modoSeleccionReporte = () => (
        <div className="flex justify-content-between flex-wrap gap-2 w-full">
            <Button
                label="Por Cliente" className={`w-full sm:w-5 ${modoReporte === 'cliente' ? 'p-button-primary' : 'p-button-outlined'}`}
                onClick={() => { setModoReporte('cliente'); reset(); setClienteSeleccionado(null); }}
            />
            <Button
                label="Por Empresa" className={`w-full sm:w-5 ${modoReporte === 'empresa' ? 'p-button-help' : 'p-button-outlined'}`}
                onClick={() => { setModoReporte('empresa'); reset(); setClienteSeleccionado(null); }}
            />
        </div>
    );

    const busquedaTemplate = () => {
        if (modoReporte === 'empresa') {
            return (
                <div className="formgrid grid align-items-center">
                    <div className="field col-12">
                        {inDropMultiple('empresa', catalogos?.catalogo_empresas, {}, 12)}
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className="formgrid grid align-items-center">
                    <div className="field col-12 flex align-items-center gap-3">
                        <label className="font-bold">Modo de Búsqueda:</label>
                        <ToggleButton checked={buscarPorNombre} onChange={(e) => { setBuscarPorNombre(e.value); reset() }} onLabel="Por Nombres"
                            offLabel="Por Identificación" onIcon="pi pi-user" offIcon="pi pi-id-card" className="w-auto" />
                    </div>
                    {buscarPorNombre ? (
                        <>
                            {inAutocomplete('nombres', clienteSeleccionado, setClienteSeleccionado, catalogoClientes, buscarClientes, { lab: 'label', val: 'cli_id', noEsActividad: true, col: 6 })}
                            <div className="field col-6">
                                <label className="font-bold">Nombres</label>
                                <InputText value={clienteSeleccionado?.nombres || ''} readOnly className="w-full" />
                            </div>
                            <div className="field col-6">
                                <label className="font-bold">Tipo de Identificación</label>
                                <InputText value={catalogos?.tipo_identificacion?.find(t => t.value === clienteSeleccionado?.tipo_identificacion_id)?.label || ''} readOnly className="w-full" />
                            </div>
                            <div className="field col-6">
                                <label className="font-bold">Identificación</label>
                                <InputText value={clienteSeleccionado?.identificacion || ''} readOnly className="w-full" />
                            </div>
                        </>
                    ) : (
                        <>
                            {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, {}, 6)}
                            {inAutocomplete('identificacion', clienteSeleccionado, setClienteSeleccionado, catalogoClientes, buscarClientes, { lab: 'label', val: 'cli_id', noEsActividad: true, col: 6 })}
                            <div className="field col-6">
                                <label className="font-bold">Nombres</label>
                                <InputText value={clienteSeleccionado?.nombres || ''} readOnly className="w-full" />
                            </div>
                            <div className="field col-6">
                                <label className="font-bold">Tipo de Identificación</label>
                                <InputText value={catalogos?.tipo_identificacion?.find(t => t.value === clienteSeleccionado?.tipo_identificacion_id)?.label || ''} readOnly className="w-full" />
                            </div>
                            <div className="field col-6">
                                <label className="font-bold">Identificación</label>
                                <InputText value={clienteSeleccionado?.identificacion || ''} readOnly className="w-full" />
                            </div>
                        </>
                    )}
                </div>
            </>
        );
    };

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    };

    const limpiarArchivo = () => {
        setArchivoMasivo(null);
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

    const buscarSugerenciasEmpresa = (texto) => {
        return monitoreoService.consultarInfo('administracion/catalogo/empresas', { texto }).then((res) => {
            return res.data
        }).catch((error) => {
            generic.funcSistemaError(error, toast);
            return [];
        }).finally(() => {

        });
    };

    // Función para capturar el archivo seleccionado
    const onFileSelect = (e) => {
        setArchivoMasivo(e.files[0]);
    };

    const cerrarDialogUpload = () => {
        setDialogUpload(false);
        setArchivoMasivo(null);
        setEmpresaSelUpload(null);
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

    // Función para enviar al backend
    const procesarCargaMasiva = () => {
        if (!archivoMasivo) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe seleccionar un archivo Excel.', life: 4000 });
            return;
        }
        if ((esAdmin || (catalogos.catalogo_empresas && catalogos.catalogo_empresas.length > 1)) && !empresaSelUpload) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe seleccionar una empresa para la carga masiva.', life: 4000 });
            return;
        }
        setLoadUpload(true);
        const formData = new FormData();
        formData.append('file', archivoMasivo);
        formData.append('tipo', 'transaccion');
        if (empresaSelUpload) {
            const empresaId = typeof empresaSelUpload === 'object' ? empresaSelUpload.value : empresaSelUpload;
            formData.append('empresa', empresaId);
        }

        monitoreoService.subirArchivoHibrido('monitoreo/cliente/carga-masiva', formData).then((res) => {
            const headerConsulta = res.headers['x-consulta']; // Cabecera especial cuando llega un blob
            if (!headerConsulta) {
                // NO HAY CABECERA -> Es un JSON de éxito (sendResponse)
                res.data.text().then(text => {
                    const info = JSON.parse(text);
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: info.message || 'Carga masiva procesada correctamente', life: 6000 });
                    cerrarDialogUpload();
                    tablaEstado.refreshData();
                });
            } else {
                // SÍ HAY CABECERA -> El backend nos envió el Excel de errores
                toast.current.show({ severity: 'error', summary: 'Errores detectados', detail: 'El archivo contiene errores, se descargará el reporte.', life: 6000 });
                // Forzamos la descarga del blob en el navegador
                const urlBlob = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = urlBlob;
                link.setAttribute('download', headerConsulta); // Usamos el nombre que vino en la cabecera
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadUpload(false);
        });
    };

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <ConfirmDialog group="confirmar" className="dialog-personalizado" />
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nueva transacción', permss)} end={rightTool} />
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} catalogos={catalogos} dataKey="id" acciones={ColumnaAcciones} />
            </Card>
            <Dialog header={dialogFechasHeader} visible={dialogFechas} style={{ width: '40vw', maxWidth: '600px' }} modal
                onHide={() => { setDialogFechas(false); setClienteSeleccionado(null); reset(); setRangoFechas([null, null]) }}
                className="dialog-personalizado">
                <div className="flex flex-column gap-4 p-2">
                    {siOpcion("monitoreo-transaccion-reporte-empresa") && modoSeleccionReporte()}
                    {busquedaTemplate()}
                    <div className="flex justify-content-between gap-3 w-full items-center">
                        <Calendar locale="es" value={rangoFechas?.[0] || null} dateFormat="yy-mm-dd" showIcon placeholder="Fecha de inicio" className="w-full" style={{ maxWidth: '35%' }} minDate={minDate} maxDate={maxDate} readOnlyInput
                            onChange={(e) => {
                                const nuevaFechaInicio = e.value;
                                const fechaFin = rangoFechas?.[1];
                                const nuevaFechaFin = fechaFin && nuevaFechaInicio && nuevaFechaInicio > fechaFin ? null : fechaFin;
                                setRangoFechas([nuevaFechaInicio, nuevaFechaFin]);
                            }}
                        />
                        <Calendar locale="es" value={rangoFechas?.[1] || null} dateFormat="yy-mm-dd" showIcon placeholder="Fecha de fin" className="w-full" style={{ maxWidth: '35%' }} minDate={rangoFechas?.[0] || minDate} maxDate={maxDate} readOnlyInput
                            onChange={(e) => setRangoFechas([rangoFechas?.[0] || null, e.value])} />
                        <Button label="Aceptar" loading={loadPdf || loadExcel} disabled={!((clienteSeleccionado?.cli_id || empresasSeleccionadas.length > 0) && rangoFechas?.[0] && rangoFechas?.[1])} className="w-full" style={{ maxWidth: '20%', whiteSpace: 'nowrap' }} onClick={() => { exportar(); }} />
                    </div>
                    <span style={{ color: 'red', fontSize: '9px', fontWeight: 'bold' }}>*El rango máximo permitido para el reporte es de {diasMaxDescargaReporte} días</span>
                </div>
            </Dialog>
            <Dialog
                visible={dialogTransaccion}
                header={customDialogHeader}
                modal
                className="p-fluid dialog-personalizado"
                onHide={() => { setDialogTransaccion(false); setClienteSeleccionado(null); reset(); }}
                style={{ minWidth: '700px', maxWidth: '800px' }}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Stepper ref={stepperRef} style={{ flexBasis: '100%' }} linear={getValues('id') == null} headerPosition="right">
                        <StepperPanel header={"Información de Transacción"}>
                            <div className="formgrid grid">
                                <div className="col-12">
                                    <Card className="mb-3">
                                        {busquedaTemplate()}
                                    </Card>
                                </div>
                                <div className="col-12 mt-2 mb-2">
                                    <span className="text-primary font-bold text-lg">Datos Generales</span>
                                    <hr className="mt-2 border-top-1 border-300" />
                                </div>
                                {inText('codigo', {}, 6)}
                                {inCalendar('fecha', {}, 6)}
                                {inDrop('tipo_producto', catalogos?.tipo_producto, { lab: 'label' }, 6)}
                                {inDrop('tipo_instrumento', catalogos?.instrumento_pago, { lab: 'label', mul: true }, 6)}

                                {inNumber('valor', 2, false, { icon: 'pi pi-dollar' }, 6)}
                                <div className="col-6 hidden md:block"></div>
                                {inText('detalle', {}, 12)}
                                <div className="col-12 mt-4 mb-2">
                                    <span className="text-primary font-bold text-lg">Datos de Ubicación</span>
                                    <hr className="mt-2 border-top-1 border-300" />
                                </div>
                                {inDrop('pais_id', catalogos?.paises, { lab: 'label', chn: onChangePais }, 6)}
                                {ecuador && inDrop('provincia_id', catalogos?.provincias, { lab: 'label', chn: onChangeProvincia }, 6)}
                                {ecuador && inDrop('ciudad_id', ciudades.map(c => ({ label: c.nombre, value: c.cat_id })), { lab: 'label' }, 6)}
                                {!ecuador && inText('ciudad', {}, 6)}
                            </div>
                            <div className="flex pt-5 justify-content-end">
                                <Button label="Guardar" icon="pi pi-save" type="submit" loading={load} style={{ minWidth: '140px', width: 'auto' }} />
                            </div>
                        </StepperPanel>
                    </Stepper>
                </form>
            </Dialog>
            <Dialog visible={dialogUpload} header="Carga Masiva de Clientes y Transacciones" modal className="p-fluid dialog-personalizado" onHide={cerrarDialogUpload} style={{ maxWidth: '460px' }}>
                <div className="p-4">
                    <div className="flex align-items-start gap-3 mb-4">
                        <div className="flex-shrink-0 flex align-items-center justify-content-center border-round-lg" style={{ width: '52px', height: '52px', background: 'var(--green-50)' }}>
                            <i className="pi pi-file-excel text-3xl" style={{ color: 'var(--green-700)' }}></i>
                        </div>
                        <div>
                            <h4 className="m-0 mb-1 text-900">Importar datos</h4>
                            <p className="m-0 text-color-secondary line-height-3 text-sm">
                                Selecciona el archivo Excel previamente llenado usando la plantilla oficial.
                            </p>
                        </div>
                    </div>

                    {(esAdmin || (catalogos.catalogo_empresas && catalogos.catalogo_empresas.length > 1)) && (
                        <div className="field mb-4">
                            <label className="font-bold block mb-2 text-sm">Empresa *</label>
                            {esAdmin ? (
                                <FiltroUnicoAutocomplete id="ac-empresa-up" value={empresaSelUpload} onChange={setEmpresaSelUpload} fetchData={buscarSugerenciasEmpresa} placeholder="Buscar empresa..." />
                            ) : (
                                <FiltroUnicoCatalogoFijo value={empresaSelUpload} options={catalogos.catalogo_empresas} onChange={setEmpresaSelUpload} placeholder="Seleccione Empresa" icon="pi pi-building" />
                            )}
                        </div>
                    )}

                    {!archivoMasivo ? (
                        <FileUpload ref={fileUploadRef} mode="basic" customUpload={true} uploadHandler={() => { }} accept=".xls,.xlsx"
                            maxFileSize={10000000} onSelect={onFileSelect} auto={false} chooseLabel="Seleccionar Archivo Excel"
                            chooseOptions={{ icon: 'pi pi-fw pi-upload', className: 'p-button-outlined p-button-secondary w-full border-dashed', }}
                            className="mb-4 w-full" />
                    ) : (
                        <div className="flex align-items-center justify-content-between p-3 border-1 border-green-300 border-round mb-4 bg-green-50">
                            <div className="flex align-items-center gap-3">
                                <i className="pi pi-file-excel text-green-600 text-2xl"></i>
                                <div className="flex flex-column">
                                    <span className="text-green-800 font-medium text-sm">
                                        {archivoMasivo.name}
                                    </span>
                                    <span className="text-xs text-green-600">
                                        {(archivoMasivo.size / 1024 / 1024).toFixed(2)} MB
                                    </span>
                                </div>
                            </div>
                            <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text p-button-sm m-0 p-2" onClick={limpiarArchivo} tooltip="Quitar archivo" tooltipOptions={{ position: 'top' }} disabled={loadUpload} type="button" />
                        </div>
                    )}

                    <div className="flex gap-2 w-full mt-2">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary w-full" onClick={cerrarDialogUpload} disabled={loadUpload} />
                        <Button label="Procesar Excel" icon="pi pi-cloud-upload" className="p-button-primary w-full" onClick={procesarCargaMasiva} loading={loadUpload} disabled={!archivoMasivo} />
                    </div>
                </div>
            </Dialog>
        </>
    )
}
